export default __webpack_public_path__ + "static/media/Futbol.877c7219.png";